import clsx from 'clsx';
import A from 'components/atoms/A/A';
import ExternalLink from 'components/atoms/ExternalLink/ExternalLink';
import TextInput from 'components/atoms/TextInput/TextInput';
import Txt from 'components/atoms/Txt/Txt';
import { useCountdownTimer } from 'hooks/useCountdownTimer';
import React from 'react';
import OtpInput from 'react-otp-input';
import classes from './SecondFactorCode.module.scss';

export type Props = {
  className?: string;
  username?: string;
  returnHref: string;
  initialText?: string;
  actionText?: string;
  onAllInputsFilled?: (filled: boolean) => void;
};

const SecondFactorCode = ({
  className,
  username,
  returnHref,
  initialText,
  actionText,
  onAllInputsFilled,
}: Props) => {
  const [otp, setOtp] = React.useState('');
  const { timeLeft, formatTime } = useCountdownTimer('secondFactorCountdown');

  React.useEffect(() => {
    if (onAllInputsFilled) {
      // A check if the OTP is filled and valid
      // Assuming OTP is valid if it is 6 digits long and only contains numbers
      onAllInputsFilled(otp.length === 6 && /^\d{6}$/.test(otp));
    }
  }, [otp, onAllInputsFilled]);

  return (
    <>
      <div className={clsx(classes.root, className)}>
        <Txt component="label" htmlFor="otpInput" className={classes.labelText}>
          Verify Code
        </Txt>
        <Txt component="p" className={classes.descriptionText}>
          Enter the <strong>6 Digit Code</strong> that we sent to:
        </Txt>
        <Txt component="p" className={classes.usernameText} skipTranslation>
          {username}
        </Txt>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          inputType="number"
          containerStyle={classes.containerStyles}
          renderInput={(props, index) => (
            <TextInput
              id={`otp-input-${index}`}
              noMinWidth
              inputClassName={classes.otpInput}
              maxLength={1}
              {...props}
            />
          )}
        />

        <input type="hidden" name="2fa_code" value={otp} />
      </div>
      <div className={classes.resendContainer}>
        <Txt component="p">Didn&apos;t receive the text?</Txt>
        <div>
          {timeLeft === 0 ? (
            <A href={returnHref} className={classes.afterExpires}>
              <Txt>{actionText}</Txt>
            </A>
          ) : (
            <>
              <Txt component="span" className={classes.beforeExpires}>
                {initialText}
              </Txt>
              <Txt component="span" className={classes.beforeExpires} skipTranslation>
                {formatTime(timeLeft)}
              </Txt>
            </>
          )}
        </div>
      </div>
      <div className={classes.helpText}>
        <Txt className={classes.problems}>Having Problems?</Txt>{' '}
        <ExternalLink link="help" href={process.env.NEXT_PUBLIC_HELPCENTER_URL || ''}>
          <Txt>Contact Support</Txt>
        </ExternalLink>
      </div>
    </>
  );
};

export default SecondFactorCode;
